import _initializerDefineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _createClass from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _defineProperty from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5;
import request from '@/utils/request';
import { wrapperGet, wrapperPost, wrapperPut } from '@/utils/http';
import { setRequestHeaderDecorator, setResponseDataDecorator } from 'decor-core';
import { handleResponseTarget } from 'decor-core/lib/handle';
import { setLoadingDecorator, setMessageDecorator } from '@/api/common';
export default new (_dec = setMessageDecorator({
  successMsg: '修改成功'
}), _dec2 = setResponseDataDecorator(handleResponseTarget('data')), _dec3 = setRequestHeaderDecorator({
  requestChannel: 'UBQ_H5'
}), _dec4 = setResponseDataDecorator(handleResponseTarget('data')), _dec5 = setResponseDataDecorator(handleResponseTarget('data')), (_class = /*#__PURE__*/_createClass(function AccountApi() {
  _classCallCheck(this, AccountApi);
  /*
   * 获取用户基本信息
   * */
  _defineProperty(this, "findUserInfo", wrapperGet('/api/client-ubq-app/user/findUserInfo'));
  // 我的页面展厅和能量信息
  _defineProperty(this, "getUserInfo", wrapperGet('api/client-ubq-app/game/energy/user/info'));
  /*
   *  修改用户信息
   * */
  _initializerDefineProperty(this, "changeUserInfo", _descriptor, this);
  // 修改用户信息
  /*
   * 个人用户实名认证拉起活体认证
   * */
  _defineProperty(this, "getAliYunCertify", wrapperPost('/api/client-ubq-app/ability/getAliYunCertify'));
  // 个人用户实名认证拉起活体认证
  /*
   * 个人用户实名认证回调
   * */
  _defineProperty(this, "realNameCallback", wrapperPost('/api/client-ubq-app/ability/realNameCallback'));
  // 个人用户实名认证回调
  /*
   * 企业用户实名认证提交
   * */
  _defineProperty(this, "companyRealName", wrapperPost('/api/opuser/realNameApprove'));
  // 企业用户实名认证提交
  /*
   *  交易信息
   * */
  // getTransactionFlow = wrapperPost('/api/opclearing/account/pageTransactionFlowByAppV2') // 交易信息
  _defineProperty(this, "getTransactionFlow", wrapperPost('/api/opclearing/account/order/page'));
  // 交易信息
  /*
   * 获取用户勋章列表
   * */
  _defineProperty(this, "getMedalList", wrapperGet('/api/opuser/memberUserInfo/getMedalList'));
  // 获取用户勋章列表
  /*
   * 获取个人信息and勋章数量
   * */
  _defineProperty(this, "getMedalNum", wrapperGet('/api/client-ubq-app/user/getHomepage'));
  // 获取个人信息and勋章数量
  /*
   * 提现记录
   * */
  _defineProperty(this, "listWithdrawsByUbqApp", wrapperPost('/api/opservcenter/listWithdrawsByUbqApp'));
  /*
   * H5充值
   * */
  _defineProperty(this, "h5PaySign", wrapperPost('/api/opclearing/fuioupay/h5PaySign'));
  /*
   * 下载作品原件发送邮箱
   * */
  _defineProperty(this, "setProductMail", wrapperPost('/api/opuser/sendProductMail'));
  /*
   * 获取个体工商户办理状态
   * */
  _defineProperty(this, "getIndividualStatus", wrapperGet('/api/opuser/individual/getStatus'));
  /*
   * 个体工商户认证
   * */
  _defineProperty(this, "individualApprove", wrapperPost('/api/opuser/individual/approve'));
  /*
   * 查询最近绑定可用银行卡
   * */
  _defineProperty(this, "getActiveBankInfo", wrapperGet('/api/opuser/getUserInfo4FuiouWallet'));
  /*
   * 开通富友钱包
   * */
  _defineProperty(this, "openFuYouWallet", wrapperPost('/api/opuser/openFuYouWallet'));
  /*
   * 获取银行列表
   * */
  _defineProperty(this, "getBankList", wrapperPost('/api/opservcenter/listBank'));
  /*
   * 查询企业用户银行开户行
   * */
  _defineProperty(this, "queryBankListFuzzy", wrapperPost('/api/opuser/queryBankListFuzzy'));
  /*
   * 获取权益兑换记录
   * */
  _defineProperty(this, "getExchangeRecord", wrapperGet('/api/client-ubq-app/privilege/exchangeRecord'));
  /*
   *  权益兑换批次列表
   * */
  _defineProperty(this, "getExchangeBatches", wrapperGet("/api/client-ubq-app/privilege/exchangeBatches"));
  /*
   *  权益批次兑换详情列表
   * */
  _initializerDefineProperty(this, "getBatchDetailList", _descriptor2, this);
  /*
   * 获取个人主页用户信息
   * */
  _defineProperty(this, "getHomepage", wrapperGet('/api/client-ubq-app/user/getHomepage'));
  /*
   * 分页获取个人主页动态信息
   * */
  _defineProperty(this, "pageDynamics", wrapperGet('/api/client-ubq-app/user/pageDynamics'));
  /*
   * 分页获取个人关注列表
   * */
  _defineProperty(this, "pageInterestList", wrapperPost('/api/opuser/pageInterestList'));
  /*
   * 获取充值方式(充值/提现/购买渠道列表接口)
   * */
  _initializerDefineProperty(this, "payChannelListV2", _descriptor3, this);
  /*
   * 更新订单（完成充值）
   * */
  _defineProperty(this, "rechargeUpdate", wrapperGet('/api/opclearing/payment/order/recharge/update'));
  /*
   * 查询充值码
   * */
  _defineProperty(this, "rechargeCodeGet", wrapperGet('/api/opclearing/order/recharge/code/get'));
  /*
   * 获取充值码(预下单)
   * */
  _defineProperty(this, "rechargeCodePost", wrapperPost('/api/opclearing/fuioupay/recharge/code/get'));
  /*
   * 查询充值详情
   * */
  _defineProperty(this, "orderDetailGet", wrapperGet('/api/opclearing/order/detail/get'));
  /*
   * 判断是否有登录密码
   * */
  _defineProperty(this, "hasPasswordStatus", wrapperGet("/api/opuser/loginPasswordStatus"));
  /*
   * 获取钱包开通信息
   * */
  _defineProperty(this, "getWallectType", wrapperGet("/api/client-ubq-app/user/findWalletType"));
  /*
   * 提现之前查询相关数据
   * */
  _defineProperty(this, "withdrawExpendInfo", wrapperPost("/api/opservcenter/withdraw/expend/info"));
  /*
   * 提现
   * */
  _defineProperty(this, "withdraw", wrapperPost("/api/opservcenter/withDrawV3"));
  /*
   * 解绑银行卡
   * */
  _defineProperty(this, "unbindBank", wrapperPost("/api/opclearing/account/bank/unbind"));
  /*
   * 转赠记录列表
   * */
  _defineProperty(this, "getGiftRecordList", wrapperGet("/api/client-ubq-app/auction/view/gift/record/list"));
  /*
   * 【我的】获取资产总数
   * */
  _defineProperty(this, "getAssetsTotal", wrapperGet("/api/client-ubq-app/assets/total"));
  /*
   * 开通易宝钱包获取开通钱包url
   * */
  _defineProperty(this, "getOpenYeeWalletUrl", wrapperGet("/api/client-ubq-app/user/getOpenYeeWalletUrl"));
  /*
   * 支付渠道查询
   * PS：因为App与H5的支付渠道存在差异，因此在App内使用H5时，需固定requestChannel=UBQ_H5
   * */
  _initializerDefineProperty(this, "getPaymentChannel", _descriptor4, this);
  /*
   * 邀请好友人数
   * */
  _defineProperty(this, "getInviteNum", wrapperGet('/api/client-ubq-app/user/inviteNum'));
  /*
   * 邀请详情
   * */
  _defineProperty(this, "getInviteRecord", wrapperGet('/api/client-ubq-app/user/inviteRecord'));
  /*
   * 兑换记录权益类型Tab
   * */
  _initializerDefineProperty(this, "getExchangeRecordTabList", _descriptor5, this);
  /*
   * 提现记录详情
   * */
  _defineProperty(this, "getWithdrawalDetail", function (bizId) {
    return wrapperGet("/api/opservcenter/getWithdrawsDetailByUbq?bizId=".concat(bizId));
  });
  /*
   * 设置个人首页是否可见
   * */
  _defineProperty(this, "setPersonalPrivacy", function (status) {
    return wrapperGet("/api/client-ubq-app/user/privacy/".concat(status));
  });
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "changeUserInfo", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPut('/api/opuser/user');
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "getBatchDetailList", [setLoadingDecorator], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet("/api/client-ubq-app/privilege/batchDetailList");
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "payChannelListV2", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/opuser/bankCard/payChannelListV2');
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "getPaymentChannel", [_dec3, _dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperPost("/api/client-ubq-app/payment/channel");
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "getExchangeRecordTabList", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function initializer() {
    return wrapperGet('/api/client-ubq-app/privilege/exchangeRecord/tab/list');
  }
})), _class))();

// 邀请好友人数
export function getInviteNum(params) {
  return request({
    url: '/api/client-ubq-app/user/inviteNum',
    method: 'get',
    params: params
  });
}

// 邀请详情
export function getInviteRecord(params) {
  return request({
    url: '/api/client-ubq-app/user/inviteRecord',
    method: 'get',
    params: params
  });
}
// 邀请达人榜
export function getInviteRank(params) {
  return request({
    url: '/api/client-ubq-app/user/inviteRank',
    method: 'get',
    params: params
  });
}

/*
 * 后台返回的user信息转换成传回后台的user
 * 坑爹的后台接口
 * */
export function transformUser(user) {
  return {
    attributes: user.attributes || [],
    displayData: {
      bucketName: user.bucketName || null,
      avatar: user.avatar,
      country: user.country || '86',
      displayName: user.displayName,
      sex: user.sex || 'u'
    }
  };
}